"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAppThunkDispatch = exports.useAppSelector = exports.rootReducer = void 0;
var toolkit_1 = require("@reduxjs/toolkit");
var react_redux_1 = require("react-redux");
var ModelResultSlice_1 = require("../store/slice/ModelResultSlice");
var PredictiveModelSlice_1 = require("../store/slice/PredictiveModelSlice");
var SubspaceSlice_1 = require("../store/slice/SubspaceSlice");
exports.rootReducer = (0, toolkit_1.combineReducers)({
    modelResult: ModelResultSlice_1.default,
    predictiveModel: PredictiveModelSlice_1.default,
    subspace: SubspaceSlice_1.default,
});
exports.useAppSelector = react_redux_1.useSelector;
var useAppThunkDispatch = function () { return (0, react_redux_1.useDispatch)(); };
exports.useAppThunkDispatch = useAppThunkDispatch;
//# sourceMappingURL=RootReducer.js.map